import { Box } from '@mui/material'
import { Grid } from '.'

interface UniversalDataGridLayoutTypes {
    cookieCrumbs?: React.ReactNode
    toolbar?: React.ReactNode
    dataGrid: React.ReactNode
    tabBar?: React.ReactNode
}

export const UniversalDataGridLayout = ({
    cookieCrumbs,
    toolbar,
    tabBar,
    dataGrid,
}: UniversalDataGridLayoutTypes) => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                overflow: 'visible',
                marginTop: 10,
                bgcolor: 'primary',
            }}
        >
            <Box sx={{ px: 3, py: 2, borderBottom: 1, borderColor: 'divider' }}>
                {cookieCrumbs}
            </Box>

            {tabBar ? <Box>{tabBar}</Box> : null}

            {toolbar && <Box sx={{ p: 2 }}>{toolbar}</Box>}

            <Box
                sx={{
                    flexGrow: 1,
                    overflow: 'visible',
                    width: '100%',
                    height: '100%',
                    bgcolor: 'primary',
                }}
            >
                {dataGrid}
            </Box>
        </Box>
    )
}

const UniversalLayouts = {
    UniversalDataGridLayout,
}

export default UniversalLayouts
